import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalUtilityDto } from "../dto/solar-proposal-utility.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Both sides' utility selection and the options the server allows for each.
 * Reading never queues work at the gateway.
 */
export default function useSolarProposalUtility(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalUtilityDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.utility(proposalId ?? ``),
    queryFn: () => solarProposalService.getUtility(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
